import React from 'react';
import { Box, Text, Button } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const UnauthorizedPage = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const handleGoBack = () => {
    const token = sessionStorage.getItem('accessToken');

    // If user NOT logged in → go sign in
    if (!token) {
  history.push("/auth/sign-in/default");
      return;
    }

    // If logged in → go home dashboard
    history.push('/admin/Main%20Dashboard/');
  };

  return (
    <Box
      textAlign="center"
      mt="100px"
      p="20px"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="8px"
      boxShadow="sm"
    >
      <Text fontSize="3xl" fontWeight="bold" mb="20px">
        {t("Unauthorized Access")}
      </Text>

      <Text mb="20px">
        {t("Sorry, you do not have the necessary permissions to view this page.")}
      </Text>

      <Button onClick={handleGoBack} colorScheme="teal">
        {t("Go Back")}
      </Button>
    </Box>
  );
};

export default UnauthorizedPage;